<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="form.valid && !form.pristine" [class.error]="!form.valid && !form.pristine">{{ title }}</h2>
            </div>
            <div>
                <mat-icon *ngIf="form.pristine && !panelOpen" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="form.pristine && panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && form.valid" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && !form.valid" class="header-toggle error">
                    close
                </mat-icon>
           </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-body-container mx-2">
        <form [formGroup]="form">
            <div class="row">
                <div class="col">
                    <div class="mt-3 d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>When did the damage occur? <span class="required-input">**</span></mat-label>
                            <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" formControlName="damage_date" >
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            <mat-error *ngIf="!form.get('damage_date')?.value">Required</mat-error>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="d-flex flex-column mt-4">
                        <mat-label>Provide a description of the damage and what caused the damage <span class="required-input">**</span></mat-label>
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <textarea matInput placeholder="Description" #description formControlName="damage_description"></textarea>
                            <mat-error *ngIf="!form.get('description')?.value">Required</mat-error>
                        </mat-form-field>
                    </div>
                    <form formGroupName="lossForm">
                        <div class="d-flex flex-column mt-4">
                            <mat-label>Describe the loss: <span class="required-input">*</span></mat-label>
                            <mat-checkbox class="mt-1" formControlName="claim_cause_damage_rental_property">
                                Damage to rental property
                            </mat-checkbox>
                            <mat-checkbox class="mt-1" formControlName="claim_cause_damage_guest_property">
                                Damage to guest's property
                            </mat-checkbox>
                            <mat-checkbox class="mt-1" formControlName="claim_cause_injury" (change)="onInjuryCheckboxChange($event)">
                                Injury
                            </mat-checkbox>
                            <mat-checkbox class="mt-1" formControlName="claim_cause_theft_fire" (change)="onTheftOrFireCheckboxChange($event)">
                                Theft or Fire
                            </mat-checkbox>
                            <mat-checkbox class="mt-1" formControlName="claim_cause_other">
                                Other loss
                            </mat-checkbox>
                        </div>
                    </form>
                    <div class="border px-2 mt-3" *ngIf="form.get('lossForm.claim_cause_injury')?.value == true">
                        <form [formGroup]="injuryForm">
                            <div class="d-flex flex-column mt-3">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Injured Name <span class="required-input">*</span></mat-label>
                                    <input matInput type="text" placeholder="Injured Name" formControlName="injury_name">
                                    <mat-error *ngIf="!form.get('injury_name')?.value">Required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="d-flex flex-column mt-3">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Phone <span class="required-input">*</span></mat-label>
                                    <input matInput type="text" placeholder="Phone" formControlName="injury_phone" (input)="onInjuryPhoneNumberChange($event)">
                                    <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                                    <mat-error *ngIf="!form.get('injury_phone')?.value">Required | Ex: (XXX) XXX-XXXX</mat-error>
                                </mat-form-field>
                            </div>
                            <div formGroupName="injury_address">
                                <div class="d-flex flex-column mt-3">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>Address Line 1 <span class="required-input">*</span></mat-label>
                                        <input matInput type="text" placeholder="Address Line 1" formControlName="address_line_1">
                                        <mat-error *ngIf="!form.get('address_line_1')?.value">Required</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="d-flex flex-column mt-3">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Address Line 2</mat-label>
                                        <input matInput type="text" placeholder="Address Line 2" formControlName="address_line_2">
                                    </mat-form-field>
                                </div>
                                <div class="d-flex flex-column mt-3">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>City <span class="required-input">*</span></mat-label>
                                        <input matInput type="text" placeholder="City" formControlName="city">
                                        <mat-error *ngIf="!form.get('city')?.value">Required</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="d-flex flex-column mt-3" *ngIf="shouldShowStateInput(); else internationalProvince">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>State <span class="required-input">*</span></mat-label>
                                        <mat-select formControlName="state">
                                            <mat-option *ngFor="let state of this.states" [value]="state.value">{{ state.label }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="!form.get('state')?.value">Required</mat-error>
                                    </mat-form-field>
                                </div>
                                <ng-template #internationalProvince>
                                    <div class="d-flex flex-column mt-3">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <mat-label>State/Province <span class="required-input">*</span></mat-label>
                                            <input matInput type="text" placeholder="State/Province" formControlName="state">
                                            <mat-error *ngIf="!form.get('state')?.value">Required</mat-error>
                                        </mat-form-field>
                                    </div>
                                </ng-template>
                                <div class="d-flex flex-column mt-3">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>Postal Code<span class="required-input">*</span></mat-label>
                                        <input matInput type="text" placeholder="Postal Code" formControlName="postal_code">
                                        <mat-error *ngIf="!form.get('postal_code')?.value">Required</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="d-flex flex-column mt-3">
                                    <mat-form-field class="full-width" appearance="outline" hideRequiredMarker>
                                        <mat-label>Country <span class="required-input">**</span></mat-label>
                                        <mat-select formControlName="country_id">
                                            <mat-option *ngFor="let country of this.countries" [value]="country.id">{{ country.display_text }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="!form.get('country_id')?.value">Required</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="d-flex flex-column mt-3">
                                <mat-label>Please give us a brief description of the injuries </mat-label>
                                <mat-form-field appearance="outline">
                                    <textarea matInput placeholder="Description" formControlName="injury_description"></textarea>
                                </mat-form-field>
                            </div>
                        </form>
                    </div>
                    <div class="border px-2 mt-3" *ngIf="form.get('lossForm.claim_cause_theft_fire')?.value == true">
                        <form [formGroup]="governmentForm">
                            <div class="d-flex flex-column mt-3">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Police/Fire Department Name <span class="required-input">*</span></mat-label>
                                    <input matInput type="text" placeholder="Police/Fire Department Name" formControlName="name">
                                    <mat-error *ngIf="!form.get('name')?.value">Required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="d-flex flex-column mt-3">
                                <mat-form-field appearance="outline">
                                    <mat-label>Case # </mat-label>
                                    <input matInput type="text" placeholder="Case #" formControlName="case_number">
                                </mat-form-field>
                            </div>
                            <div class="d-flex flex-column mt-3">
                                <mat-form-field appearance="outline">
                                    <mat-label>Officer Name </mat-label>
                                    <input matInput type="text" placeholder="Officer Name" formControlName="officer_name">
                                </mat-form-field>
                            </div>
                            <div class="d-flex flex-column mt-3">
                                <mat-form-field appearance="outline">
                                    <mat-label>Officer Phone Number </mat-label>
                                    <input matInput type="text" placeholder="Officer Phone Number" formControlName="officer_phone" (input)="onPhoneNumberChanged($event)">
                                    <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                                </mat-form-field>
                            </div>
                        </form>
                    </div>
                    <div class="d-flex flex-column mt-4">
                        <mat-label>Total claim amount <span class="required-input">**</span></mat-label>
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <input matInput type="number" [min]="0.01" step="0.01" placeholder="100.00" formControlName="estimate_amount" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)"/>
                            <mat-error *ngIf="!form.get('estimate_amount')?.value">Required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col">
                    <div class="mt-3 d-flex flex-column">
                        <mat-label>Is the home liveable? <span class="required-input">*</span></mat-label>
                        <mat-radio-group formControlName="home_liveable">
                            <mat-radio-button [value]="1">
                                Yes
                            </mat-radio-button>
                            <mat-radio-button [value]="0" class="radio-button-margin-left">
                                No
                            </mat-radio-button>
                            <mat-error *ngIf="form.controls['home_liveable'].invalid">Required</mat-error>
                        </mat-radio-group>
                    </div>
                    <div class="mt-4 d-flex flex-column">
                        <mat-label>Do you believe the damage was accidental? <span class="required-input">*</span></mat-label>
                        <mat-radio-group formControlName="damage_accidental">
                            <mat-radio-button [value]="1">
                                Yes
                            </mat-radio-button>
                            <mat-radio-button [value]="0" class="radio-button-margin-left">
                                No
                            </mat-radio-button>
                            <mat-error *ngIf="form.controls['damage_accidental'].invalid">Required</mat-error>
                        </mat-radio-group>
                    </div>
                    <div class="mt-4 d-flex flex-column">
                        <mat-label class="mb-3">How negligent was the guest?</mat-label>
                        <mat-slider 
                            thumbLabel 
                            [displayWith]="getClaimNegligenceDescription"
                            step="1"
                            min="1"
                            max="5"
                            aria-label="units"
                            showTickMarks
                            discrete
                        >
                            <input matSliderThumb formControlName="guest_rate" />
                        </mat-slider>
                        <div class="d-flex flex-row justify-content-between">
                            <span class="text-muted"><small>purely accidental</small></span>
                            <span class="text-muted"><small>purely negligent</small></span>
                        </div>
                        <mat-error *ngIf="form.controls['guest_rate'].invalid">Required</mat-error>
                    </div>
                    <div class="mt-4 d-flex flex-column">
                        <mat-label>Would you rent to this guest again? <span class="required-input">*</span></mat-label>
                        <mat-radio-group formControlName="would_rent_again">
                            <mat-radio-button [value]="1">
                                Yes
                            </mat-radio-button>
                            <mat-radio-button [value]="0" class="radio-button-margin-left">
                                No
                            </mat-radio-button>
                            <mat-error *ngIf="form.controls['would_rent_again'].invalid">Required</mat-error>
                        </mat-radio-group>
                    </div>
                    <div class="mt-4 d-flex flex-column">
                        <mat-label>Safely Admin Note</mat-label>
                        <mat-form-field appearance="outline">
                            <textarea matInput placeholder="Safely Admin Note" formControlName="admin_comment"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="mt-4 d-flex flex-column">
                        <mat-label>Additional Comments</mat-label>
                        <mat-form-field appearance="outline">
                            <textarea matInput placeholder="Please add any additional comments" rows="6" formControlName="additional_comment" maxlength="1000"></textarea>
                            <mat-hint align="end">{{ form.get('additional_comment')?.value?.length || 0 }}/1000</mat-hint>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <mat-action-row class="mt-4 d-flex flex-row align-content-center">
                <div class="d-flex align-items-center text-muted" style="margin-right: auto;">
                    <span class="required-input">*</span>&nbsp;- Required fields before submitting claim
                </div>
            </mat-action-row>
            <div class="d-flex align-items-center text-muted" style="margin-right: auto;">
                <span class="required-input ps-3">**</span>&nbsp;- Required fields before saving draft
            </div>
        </form>
    </div>
</mat-expansion-panel>